import { MoneyText } from "@workspace/accounting/components";

import { refundSummary } from "./refund-summary";

/**
 * A refund's Subtotal and Tax rows; the Total row stays with its caller.
 *
 * HA-455: these rows formatted the pence as pounds ("Subtotal £300.00" above "Total Refund £3.00"
 * for a £3.00 item). They now go through MoneyText, which converts, as the Total row's <Money>
 * always did.
 */
export function RefundSubtotalRows({
	total,
	taxRatePercent,
	currency,
	taxLabel = `Tax (${taxRatePercent}%)`,
	labelClassName,
}: {
	total: number;
	taxRatePercent: number;
	currency: string;
	taxLabel?: string;
	labelClassName?: string;
}) {
	const { subtotal, tax } = refundSummary(total, taxRatePercent);

	return (
		<>
			<div className="flex justify-between">
				<span className={labelClassName}>Subtotal</span>
				<span data-testid="refund-subtotal">
					<MoneyText value={subtotal} currency={currency} />
				</span>
			</div>
			<div className="flex justify-between">
				<span className={labelClassName}>{taxLabel}</span>
				<span data-testid="refund-tax">
					<MoneyText value={tax} currency={currency} />
				</span>
			</div>
		</>
	);
}
